import axios, { AxiosResponse } from 'axios';
import { API_URL, MAINTENANCE_POLL_INTERVAL_MS } from '@src/config/constant';
import maintenanceManager from '@src/utils/maintenanceManager';

const STATUS_PATH = 'user/maintenance/status';

const maintenanceClient = axios.create({
  timeout: 15000,
});

interface MaintenanceCheckOptions {
  failOpen?: boolean;
}

const MaintenanceService = {
  STATUS_PATH,
  POLL_INTERVAL_MS: MAINTENANCE_POLL_INTERVAL_MS,

  isStatusRequest(url?: string): boolean {
    return !!url && url.includes(STATUS_PATH);
  },

  async fetchStatus(): Promise<AxiosResponse<any> | null> {
    try {
      return await maintenanceClient.get(`${API_URL.GETWAY_API}${STATUS_PATH}`);
    } catch (error: any) {
      return error?.response || null;
    }
  },

  async checkAndApply(options: MaintenanceCheckOptions = {}): Promise<boolean> {
    const response = await MaintenanceService.fetchStatus();

    if (!response) {
      if (options.failOpen) {
        return maintenanceManager.update(false);
      }
      return maintenanceManager.isUnderMaintenance();
    }

    return maintenanceManager.applyResponse(
      response.data,
      response.status,
      response.headers,
    );
  },
};

export default MaintenanceService;
